import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  pkgCard: {
    border: "2px solid #D4D4D4",
    borderRadius: 20,
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    gap: 30,
    overflow: "hidden",
  },
  activePkgCard: {
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  pkgNameRow: {
    padding: "16px 16px 0px 16px",
    alignItems: "center",
    justifyContent: "space-between",
    "& p": {
      margin: 0,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 400,
      color: "#979797",
      "& img": {
        marginLeft: 4,
        marginBottom: 5,
        width: 16,
      },
      "&:nth-of-type(2)": {
        color: "#525252",
        fontWeight: 600,
      },
    },
  },
  pkgPrice: {
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 700,
    color: "#262626",
    paddingInline: 12,
    margin: 0,
    "& span": {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  pkgBottomContent: {
    flex: 1,
    width: "100%",
    padding: "20px 16px 20px 16px",
    backgroundColor: "#FAFAFA",
    borderTop: "1px solid #D4D4D4",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  upgradePlanBgColor: {
    backgroundColor: "#6941C6",
  },
  price: {
    fontFamily: "Inter",
    fontSize: 22,
    color: "#232323",
    fontWeight: 600,
  },

  title: {
    display: "flex",
    flexDirection: "row",
    margin: 20,
  },
  pricetag: {
    marginLeft: "auto",
    margin: "1px solid green",
    fontSize: "13 !important",
  },
  desAndDetailsBox: {
    flex: 1,
    borderBottom: "1px solid #D4D4D4",
    paddingBottom: 20,
    marginBottom: 10,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  listParent: {
    flexDirection: "column",
    gap: 8,
    "& p": {
      margin: 0,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: 500,
      color: "#525252",
      display: "flex",
      alignItems: 'flex-start',
      gap: 10,
      '& svg':{
        marginTop: 2,
        minHeight: 20,
        minWidth: 20,
      }
    },
  },
  upgradePlanList: {
    "& p": {
      color: "#FFF !important",
    },
  },
  selectBtn: {
    width: "100%",
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: "#FFAF4A",
    border: "1px solid #FFAF4A",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 44,
    color: "#171717",
    "&:hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  upgradeBtn: {
    backgroundColor: "#FCFAFF",
    border: "1px solid #FCFAFF",
    color: "#53389E",
    "&:hover": {
      backgroundColor: "#FCFAFF",
      opacity: 0.9,
    },
  },
  cancelSubBtn: {
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 600,
    width: "100%",
    backgroundColor: "#F04438",
    border: "1px solid #F04438",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 44,
    color: "white",
    "&:hover": {
      backgroundColor: "#F04438",
      opacity: 0.9,
    },
  },
  billing: {
    fontFamily: "Inter",
    fontSize: 14,
    color: "#979797",
  },
  cycle: {
    fontFamily: "Inter",
    fontSize: 16,
    color: "#262626",
  },
  selectedtype: {
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 500,
    color: "white",
  },
  selectedPrice: {
    fontFamily: "Inter",
    fontSize: 22,
    color: "white",
    fontWeight: 600,
  },
}));

export default useStyles;
